import { Link, useParams, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { verifyLead } from "../services/leadService";
import Logo from "../components/Logo";

export default function LeadVerifyPage() {
  const { leadId, hash } = useParams();
  const [searchParams] = useSearchParams();
  const queryParams = Object.fromEntries(searchParams.entries());

  const q = useQuery({
    queryKey: ["lead", "verify", leadId, hash, queryParams],
    queryFn: () => verifyLead(leadId, hash, queryParams),
    enabled: Boolean(leadId && hash),
    retry: false,
  });

  if (q.isLoading) {
    return (
      <div className="space-y-8 text-center">
        <Logo size={32} />
        <p className="text-xs uppercase tracking-[0.22em] text-[rgba(255,255,255,0.45)]">
          Verificando enlace…
        </p>
      </div>
    );
  }

  if (q.isError) {
    return (
      <div className="space-y-8 text-center" data-testid="lead-verify-error">
        <Logo size={32} />
        <p className="text-sm text-[rgba(255,255,255,0.75)]">{q.error?.message}</p>
        <Link
          to="/auth"
          className="text-xs uppercase tracking-[0.2em] text-[#e9b5c5] hover:text-[#f5f5f5]"
        >
          Ir al acceso
        </Link>
      </div>
    );
  }

  const msg =
    q.data?.message ||
    q.data?.status ||
    "Verificación completada. Revisa tu correo para continuar.";

  return (
    <div className="space-y-8 text-center" data-testid="lead-verify-ok">
      <Logo size={32} />
      <p className="zx-label">Lead</p>
      <p className="text-sm text-[rgba(255,255,255,0.85)]">{String(msg)}</p>
      <Link
        to="/auth"
        className="inline-block text-xs uppercase tracking-[0.2em] text-[rgba(255,255,255,0.55)] hover:text-[#f5f5f5]"
      >
        Volver al acceso
      </Link>
    </div>
  );
}
